<template>
    <span class="check-session"></span>
</template>

<script lang="ts" setup>
    const router = useRouter()
    import JwtService from '@/core/services/JwtService'
    const apiClient = useApiClient()
    const getExpireTime = (token: string): number => {
        try {
            if (!token || typeof token !== 'string') {
                return -1;
            }
            
            const parts = token.split('.');
            if (parts.length !== 3) {
                return -1;
            }
            
            const payload = parts[1];
            if (!payload) {
                return -1;
            }
            
            const decode = JSON.parse(atob(payload));
            if (!decode.exp || typeof decode.exp !== 'number') {
                return -1;
            }
            
            return decode.exp * 1000 - Date.now();
        } catch (error) {
            console.error('Error decoding token:', error);
            return -1;
        }
    }
    const isMobile = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 1024;
    }
    const checkToken = () => {
        try {
            const token = JwtService.getToken();
            if (!token) {
                // No token available, skip check
                return;
            }
            
            const expiredTime = getExpireTime(token as string);
            
            // If token is invalid or malformed, skip check
            if (expiredTime === -1) {
                return;
            }
            
            // If token expires in less than 5 minutes, try to refresh
            if (expiredTime < 1000 * 60 * 5) {
                apiClient.refreshToken().then((res) => {
                    if (res.success && res.data && res.data.token) {
                        JwtService.saveToken(res.data.token);
                    } else {
                        console.warn("Failed to refresh token, response:", res);
                        // Uncomment if you want to redirect to login on refresh failure
                        // JwtService.destroyToken();
                        // window.location.href = '/account/login';
                    }
                }).catch(err => {
                    console.error("Error refreshing token:", err);
                    // Uncomment if you want to redirect to login on error
                    // JwtService.destroyToken();
                    // window.location.href = '/account/login';
                });
            }
        } catch (e) {
            console.error("Error in checkToken:", e);
            // Uncomment if you want to redirect to login on error
            // window.location.href = '/account/login';
        }
    }
    onMounted(() => {
        checkToken();
        //each 5s
        setInterval(() => {
            checkToken();
        }, 5000);
    })
</script>
